import React from "react";
import Header from "./header";

const Hero = () => {
  return (
    <>
      <section className="bg-[#456DA8] h-screen relative hidden sm:block">
        <Header />
        <div className="flex justify-start items-center gap-10">
          <div className="px-20 mt-32">
            <p className="text-2xl tracking-wider leading-10 text-white w-96">
              LOUVRE caters to thoughtful shoppers who appreciate unique designs
              and top quality pieces.
            </p>
            <button className="uppercase bg-white text-[#456DA8] px-10 py-3 rounded shadow-lg mt-5">
              shop now
            </button>
          </div>
          <div className="absolute bottom-0 right-6">
            <img
              src="https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Flourve_hero_image.png?alt=media&token=6ff3195a-d41f-45b0-b246-c94ac0ce30f0"
              alt=""
              // className="absolute bottom-0 right-6"
              className="lg:h-full h-[400px]"
            />
          </div>
        </div>
      </section>
      <section className="bg-[#456DA8] pb-20 block sm:hidden">
        <Header />
        <div className="flex justify-center h-full">
          <div className="px-10">
            <p className="text-2xl tracking-wider leading-10 text-white mt-32">
              LOUVRE caters to thoughtful shoppers who appreciate unique designs
              and top quality pieces.
            </p>
            <button className="uppercase bg-white text-[#456DA8] px-10 py-3 rounded shadow-lg mt-5">
              shop now
            </button>
            {/* <img
              src="https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Flourve_hero_image.png?alt=media&token=6ff3195a-d41f-45b0-b246-c94ac0ce30f0"
              alt=""
              className="absolute bottom-0 right-6"
              
            /> */}
          </div>
        </div>
      </section>
    </>
  );
};

export default Hero;
